import { cn } from '~/utils/cn';

interface PremiumBadgeProps {
  /** Width and height in pixels. Defaults to 16. */
  size?: number;
  className?: string;
  /** `data-testid` for the icon (default `premium-badge`). */
  testId?: string;
}

/**
 * Inline crown icon placed next to feature labels to indicate a premium capability.
 * For trial users this signals read-only access; for premium users it is hidden.
 */
export function PremiumBadge({
  size = 16,
  className,
  testId = 'premium-badge',
}: PremiumBadgeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Premium feature"
      data-testid={testId}
      className={cn('inline-block shrink-0', className)}
    >
      <path
        d="M7.70893 2.18038C7.73771 2.12811 7.77998 2.08453 7.83134 2.05418C7.88271 2.02382 7.94127 2.00781 8.00093 2.00781C8.06059 2.00781 8.11916 2.02382 8.17052 2.05418C8.22188 2.08453 8.26416 2.12811 8.29293 2.18038L10.2609 5.91638C10.3079 6.00288 10.3734 6.07793 10.4527 6.13612C10.5321 6.19431 10.6234 6.23421 10.72 6.25295C10.8166 6.27169 10.9162 6.2688 11.0116 6.24449C11.1069 6.22019 11.1957 6.17507 11.2716 6.11238L14.1229 3.66971C14.1777 3.62519 14.2451 3.59919 14.3156 3.59544C14.386 3.5917 14.4559 3.61041 14.515 3.64887C14.5741 3.68734 14.6196 3.74358 14.6447 3.8095C14.6699 3.87542 14.6734 3.94762 14.6549 4.01571L12.7656 10.8464C12.727 10.9862 12.6439 11.1095 12.5289 11.1979C12.4139 11.2862 12.2733 11.3346 12.1283 11.3357H3.87427C3.72916 11.3347 3.58834 11.2864 3.47319 11.198C3.35805 11.1097 3.27486 10.9863 3.23627 10.8464L1.3476 4.01638C1.3291 3.94829 1.33268 3.87609 1.35783 3.81017C1.38297 3.74425 1.42839 3.68801 1.48753 3.64954C1.54668 3.61107 1.61651 3.59237 1.68696 3.59611C1.75742 3.59985 1.82487 3.62586 1.8796 3.67038L4.73027 6.11304C4.80613 6.17574 4.89494 6.22086 4.99031 6.24516C5.08568 6.26947 5.18525 6.27235 5.28187 6.25362C5.37849 6.23488 5.46976 6.19498 5.54913 6.13679C5.6285 6.07859 5.694 6.00355 5.74093 5.91704L7.70893 2.18038Z"
        fill="#EABA01"
      />
      <path d="M3.33423 14.0031H12.6676Z" fill="#EABA01" />
      <path
        d="M3.33423 14.0031H12.6676M7.70893 2.18038C7.73771 2.12811 7.77998 2.08453 7.83134 2.05418C7.88271 2.02382 7.94127 2.00781 8.00093 2.00781C8.06059 2.00781 8.11916 2.02382 8.17052 2.05418C8.22188 2.08453 8.26416 2.12811 8.29293 2.18038L10.2609 5.91638C10.3079 6.00288 10.3734 6.07793 10.4527 6.13612C10.5321 6.19431 10.6234 6.23421 10.72 6.25295C10.8166 6.27169 10.9162 6.2688 11.0116 6.24449C11.1069 6.22019 11.1957 6.17507 11.2716 6.11238L14.1229 3.66971C14.1777 3.62519 14.2451 3.59919 14.3156 3.59544C14.386 3.5917 14.4559 3.61041 14.515 3.64887C14.5741 3.68734 14.6196 3.74358 14.6447 3.8095C14.6699 3.87542 14.6734 3.94762 14.6549 4.01571L12.7656 10.8464C12.727 10.9862 12.6439 11.1095 12.5289 11.1979C12.4139 11.2862 12.2733 11.3346 12.1283 11.3357H3.87427C3.72916 11.3347 3.58834 11.2864 3.47319 11.198C3.35805 11.1097 3.27486 10.9863 3.23627 10.8464L1.3476 4.01638C1.3291 3.94829 1.33268 3.87609 1.35783 3.81017C1.38297 3.74425 1.42839 3.68801 1.48753 3.64954C1.54668 3.61107 1.61651 3.59237 1.68696 3.59611C1.75742 3.59985 1.82487 3.62586 1.8796 3.67038L4.73027 6.11304C4.80613 6.17574 4.89494 6.22086 4.99031 6.24516C5.08568 6.26947 5.18525 6.27235 5.28187 6.25362C5.37849 6.23488 5.46976 6.19498 5.54913 6.13679C5.6285 6.07859 5.694 6.00355 5.74093 5.91704L7.70893 2.18038Z"
        stroke="#EABA01"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
